import { render } from "./DashboardViewMain.vue?vue&type=template&id=c63bbe8c"
import script from "./DashboardViewMain.vue?vue&type=script&lang=js"
export * from "./DashboardViewMain.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__